import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import BasicModal from './BasicModal';
import CurrencyInput from '../CurrencyInput';

interface Props {
    open: boolean;
    onClose: () => void;
    onSave?: (retornoFinanceiro: string) => void;
    acaoNome?: string;
    retornoFinanceiroInicial?: string;
}

const RetornoFinanceiroModal: React.FC<Props> = ({
    open,
    onClose,
    onSave,
    acaoNome,
    retornoFinanceiroInicial = ''
}) => {
    const [retornoFinanceiro, setRetornoFinanceiro] = useState<string>(retornoFinanceiroInicial);
    const [error, setError] = useState<boolean>(false);
    const [saving, setSaving] = useState(false);

    // Reset values when modal opens
    useEffect(() => {
        if (open) {
            setRetornoFinanceiro(retornoFinanceiroInicial);
            setError(false);
        }
    }, [open, retornoFinanceiroInicial]);

    const handleSave = async () => {
        // Validação simples - campo obrigatório
        if (!retornoFinanceiro.trim()) {
            setError(true);
            return;
        }

        setError(false);
        setSaving(true);
        try {
            await onSave?.(retornoFinanceiro.trim());
        } finally {
            setSaving(false);
        }
    };

    const handleChange = (value: string) => {
        setRetornoFinanceiro(value);
        if (error && value.trim()) {
            setError(false);
        }
    };

    const handleClose = () => {
        setRetornoFinanceiro('');
        setError(false);
        onClose();
    };

    return (
        <BasicModal
            title="Retorno Financeiro da Ação"
            open={open}
            onClose={handleClose}
            saveButton={true}
            onSave={handleSave}
            saveLoading={saving}
            sizeContent="small"
            tela='relatorios'
        >
            <Box sx={{ mt: 1 }}>
                {acaoNome && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Ação finalizada:
                        </Typography>
                        <Typography variant="body1" fontWeight="medium">
                            {acaoNome}
                        </Typography>
                    </Box>
                )}

                <Typography variant="body2" sx={{ mb: 2 }}>
                    Informe o retorno financeiro aproximado obtido com a finalização desta ação:
                </Typography>

                <CurrencyInput
                    value={retornoFinanceiro}
                    size='medium'
                    onChange={handleChange}
                    label="Retorno Financeiro da ação"
                    error={error}
                />
            </Box>
        </BasicModal>
    );
};

export default RetornoFinanceiroModal;